import { ID } from 'app/components/Table/core/types';

import { OrganizationInfo } from 'theme/layout/components/aside/store';

export enum MailType {
  ABNORMAL_CONNECTION = 'abnormal-consumption',
  FAILED_CONNECTION = 'failed-connection',
  REACH_PAR_ALARM_LEVEL = 'reach-par-alarm-level',
  REACH_CRITICAL_LEVEL = 'reach-critical-level',
  SHELF_EXPIRY = 'shelf-expiry',
  EXPIRY_CV = 'expiry-cv',
}

export interface Recipient {
  email: string;
  readAt: Date | null;
}

export interface MailStats {
  id: ID;
  createdAt: string;
  type: MailType;
  context: string;
  recipients: Recipient[];
  templateContent: string;
  sentAt: Date;
  title: string;
  organization: OrganizationInfo;
  recipientType: number;
}

export enum MailTrackingRecipientType {
  SYSTEM_ADMIN = 1,
  ORGANIZATION_ADMIN = 2,
}

export interface ApiResponse<T> {
  data: T[] | T;
  success: string;
  message: string;
}

export interface MailHistoryFilterParams {
  organizationId: string[];
  recipientType: string[];
  type: string[];
  page?: number;
}
